import { useContext, useState } from 'react'

import EditContextProvider, { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { ESTADO_CLIENTE, SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import Edit from '../../../Clients/Edit'

import SearchClient from './ClientsCTACTE/SearchClient'
import { ClientsCTACTE } from './ClientsCTACTE'
import { ClientsFACT } from './ClientsFACT'

const ClientContent = (props) => {
  const {
    data,
    setData,
    dataBefore,
    openCancel,
    cancel,
    handleclose,
    setRender,
    render,
    permissions,
  } = props
  const [edit] = useContext(EditContext)
  const createDismissableSnackbar = useCustomSnackbar()

  const BLOQUEADO = ESTADO_CLIENTE.find((e) => e.label === 'BLOQUEADO')?.value
  const INHABILITADO = ESTADO_CLIENTE.find((e) => e.label === 'INHABILITADO')?.value

  const isClientBlockedOrDisabled = (estado) => {
    const value = Number(estado)
    return value === Number(BLOQUEADO) || value === Number(INHABILITADO)
  }

  const getClientStatusMessage = (estado) => {
    const value = Number(estado)
    if (value === Number(BLOQUEADO)) return 'El cliente está bloqueado.'
    if (value === Number(INHABILITADO)) return 'El cliente está inhabilitado.'
    return 'El cliente no está habilitado.'
  }

  const [tab, setTab] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null
  const [info, setInfo] = useState({
    ...data.clienteFactura,
    search: '',
    empresa: empresaId,
  })
  const { state, setOpen, setClose } = SetState()

  async function handleSubmitCode(info) {
    setIsLoading(true)
    const values = {
      // empresa: empresaId,
      search: String(info.search),
    }
    await interfaces.salesOrders
      .searchClients(values)
      .then((res) => {
        const clientData = res.data.cliente

        if (isClientBlockedOrDisabled(clientData?.estado)) {
          createDismissableSnackbar(getClientStatusMessage(clientData?.estado), {
            variant: 'error',
          })
          return
        }
        const updatedClientData = {
          //search: clientData.cuit,
          cuit: clientData.cuit,
          nombre: clientData.nombre,
          cond_iva: clientData.cond_iva,
          tipo_responsable: clientData.tipo_responsable,
          provincia: clientData.provincia,
          localidad: clientData.localidad,
          domicilio: clientData.domicilio,
          telefono: clientData.telefono1,
          email: clientData.mail,
          cp: clientData.cp,
        }
        setInfo((prevInfo) => ({
          ...prevInfo,
          ...updatedClientData,
        }))

        setData((prevData) => ({
          ...prevData,
          clienteFactura: {
            ...prevData.clienteFactura,
            ...updatedClientData,
          },
        }))
        setRender(!render)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const handleChangeCteFact = (name, value) => {
    setData((prevData) => ({
      ...prevData,
      clienteFactura: {
        ...prevData.clienteFactura,
        [name]: value,
      },
    }))
  }

  async function clientInfo() {
    const id = data.ctaCliente.id
    const empresa = empresaId
    await interfaces.salesClients.infoOneClient(id, empresa).then((res) => {
      setOpen({
        data: res.data,
        fromOrders: true,
      })
    })
  }

  const comprobantesNDNC = [2, 7, 20, 202, 207, 3, 8, 21, 203, 208]

  const classes = useStyles()

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <InputsWithoutValidate
              fields={ClientsCTACTE(data.ctaCliente, edit, dataBefore)}
              spacing={2}
            />

            {!comprobantesNDNC.includes(data.infoMain.comprobante) && (
              <div className={classes.buttons}>
                <CustomButton
                  color="secondary"
                  buttonEnd
                  style={{
                    marginLeft: '1.5rem',
                  }}
                  text="Buscar cliente"
                  onClick={openCancel}
                  disabled={permissions.allowEditMin || data.infoMain.estado === 3 ? true : !edit}
                />

                <CustomButton
                  color="primary"
                  buttonEnd
                  style={{
                    marginLeft: '1.5rem',
                  }}
                  text="Ver cliente"
                  onClick={() => clientInfo()}
                  disabled={permissions.allowEditMin ? true : !edit}
                />
              </div>
            )}
          </>
        )
      case 1:
        return (
          <InputsWithoutValidate
            fields={ClientsFACT(
              data,
              handleChangeCteFact,
              edit,
              dataBefore,
              info,
              setInfo,
              isLoading,
              setIsLoading,
              handleSubmitCode,
              permissions,
              comprobantesNDNC
            )}
            spacing={2}
          />
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'Cliente cta cte',
    },
    {
      id: 1,
      title: 'Cliente factura',
    },
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
          <Edit
            open={state.open}
            handleclose={setClose}
            data={state.data}
            setRender={setRender}
            render={render}
            setLoading={setIsLoading}
            dataBefore={dataBefore}
            loading={isLoading}
            fromOrders={state.fromOrders}
          />
        </EditContextProvider>
      )}

      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />

      {cancel.suspense && (
        <SearchClient
          data={dataBefore.data}
          // render={render}
          // setRender={setRender}
          open={openCancel}
          handleClose={handleclose}
          setData={setData}
          dataClient={data.infoMain}
        />
      )}
    </>
  )
}

export default ClientContent
